import React, { Fragment, Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../components/Layout/Header';
import Content from './Content';
import Footer from '../../components/Layout/Footer';
import WhatsApp from '../../components/Layout/Contato/Whatsapp';

export default class Favorites extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <Fragment>
                <Helmet title={`Imóveis favoritos | ${process.env.REACT_APP_NAME}`} />
                <Header />
                <main>
                    <Content />
                </main>
                <Footer />
                <WhatsApp />
            </Fragment>
        );
    }
}